import type { Template } from "@/types";

export const LA_05_H3_V2: Template[] = [
    {
        id: "la-05-h3v2-01",
        name: "LA 01 - H3V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-05-h3_v2_01.png",
        size: [1352, 541],
        style: {},
        slots: [         
            { id: "1", x: 68, y: 54, width: 266, height: 432, rotation: 0, imageRotation: 0 },
            { id: "2", x: 342, y: 54, width: 266, height: 432, rotation: 0, imageRotation: 0 },
            { id: "3", x: 810, y: 54, width: 408, height: 283, rotation: 0, imageRotation: 0 },
            { id: "4", x: 810, y: 345, width: 200, height: 142, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1018, y: 345, width: 200, height: 142, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h3v2-02",
        name: "LA 02 - H3V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-05-h3_v2_02.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 92, y: 54, width: 207, height: 140, rotation: 0, imageRotation: 0 },
            { id: "2", x: 92, y: 202, width: 207, height: 139, rotation: 0, imageRotation: 0 },
            { id: "3", x: 92, y: 349, width: 207, height: 139, rotation: 0, imageRotation: 0 },
            { id: "4", x: 307, y: 54, width: 277, height: 432, rotation: 0, imageRotation: 0 },
            { id: "5", x: 862, y: 54, width: 305, height: 432, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h3v2-03",
        name: "LA 03 - H3V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-05-h3_v2_03.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 0, y: 69, width: 240, height: 402, rotation: 0, imageRotation: 0 },
            { id: "2", x: 248, y: 69, width: 240, height: 402, rotation: 0, imageRotation: 0 },         
            { id: "3", x: 496, y: 69, width: 283, height: 197, rotation: 0, imageRotation: 0 },
            { id: "4", x: 496, y: 274, width: 283, height: 197, rotation: 0, imageRotation: 0 },
            { id: "5", x: 787, y: 69, width: 565, height: 402, rotation: 0, imageRotation: 0 }
          
        ],
    },

    {
        id: "la-05-h3v2-04",
        name: "LA 04 - H3V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-05-h3_v2_04.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 0, y: 69, width: 565, height: 402, rotation: 0, imageRotation: 0 },
            { id: "2", x: 573, y: 69, width: 240, height: 402, rotation: 0, imageRotation: 0 },
            { id: "3", x: 821, y: 69, width: 240, height: 402, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1069, y: 69, width: 283, height: 197, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1069, y: 274, width: 283, height: 197, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h3v2-05",
        name: "LA 05 - H3V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-05-h3_v2_05.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 134, y: 48, width: 295, height: 220, rotation: 0, imageRotation: 0 },
            { id: "2", x: 134, y: 276, width: 148, height: 218, rotation: 0, imageRotation: 0 },
            { id: "3", x: 290, y: 276, width: 295, height: 218, rotation: 0, imageRotation: 0 },
            { id: "4", x: 437, y: 48, width: 148, height: 220, rotation: 0, imageRotation: 0 },
            { id: "5", x: 593, y: 48, width: 625, height: 446, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h3v2-06",
        name: "LA 06 - H3V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-05-h3_v2_06.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 134, y: 48, width: 625, height: 446, rotation: 0, imageRotation: 0 },
            { id: "2", x: 767, y: 276, width: 148, height: 218, rotation: 0, imageRotation: 0 },
            { id: "3", x: 767, y: 48, width: 148, height: 220, rotation: 0, imageRotation: 0 },
            { id: "4", x: 923, y: 48, width: 296, height: 220, rotation: 0, imageRotation: 0 },
            { id: "5", x: 923, y: 276, width: 296, height: 218, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h3v2-07",
        name: "LA 07 - H3V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-05-h3_v2_07.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 134, y: 48, width: 625, height: 446, rotation: 0, imageRotation: 0 },
            { id: "2", x: 767, y: 48, width: 296, height: 220, rotation: 0, imageRotation: 0 },
            { id: "3", x: 767, y: 276, width: 296, height: 218, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1071, y: 48, width: 148, height: 220, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1071, y: 276, width: 148, height: 218, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h3v2-08",
        name: "LA 08 - H3V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-05-h3_v2_08.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 0, y: 139, width: 339, height: 261, rotation: 0, imageRotation: 0 },
            { id: "2", x: 347, y: 139, width: 151, height: 261, rotation: 0, imageRotation: 0 },
            { id: "3", x: 506, y: 139, width: 338, height: 261, rotation: 0, imageRotation: 0 },
            { id: "4", x: 852, y: 139, width: 151, height: 261, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1011, y: 139, width: 341, height: 261, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h3v2-09",
        name: "LA 09 - H3V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-05-h3_v2_09.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 0, y: 139, width: 151, height: 261, rotation: 0, imageRotation: 0 },
            { id: "2", x: 158, y: 139, width: 339, height: 261, rotation: 0, imageRotation: 0 },
            { id: "3", x: 505, y: 139, width: 339, height: 261, rotation: 0, imageRotation: 0 },
            { id: "4", x: 852, y: 139, width: 341, height: 261, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1201, y: 139, width: 151, height: 261, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h3v2-10",
        name: "LA 10 - H3V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-05-h3_v2_10.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 134, y: 48, width: 625, height: 446, rotation: 0, imageRotation: 0 },
            { id: "2", x: 767, y: 48, width: 148, height: 220, rotation: 0, imageRotation: 0 },
            { id: "3", x: 767, y: 276, width: 295, height: 218, rotation: 0, imageRotation: 0 },
            { id: "4", x: 923, y: 48, width: 295, height: 220, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1070, y: 276, width: 148, height: 218, rotation: 0, imageRotation: 0 }
        ],
    }
];